import AddUser from './AddUser';

export default AddUser;



// WEBPACK FOOTER //
// ./src/components/AddUser/index.jsx